export const EVENT_FETCH = "EVENT_FETCH";
export const EVENT_UPLOAD = "EVENT_UPLOAD";
export const EVENT_UPDATE = "EVENT_UPDATE";
export const EVENT_SET = "EVENT_SET";
export const EVENT_REMOVE = "EVENT_REMOVE";
